import { NgModule } from '@angular/core';
import { ResizableMapComponent } from './resizable-map.component';
import { ResizableModule } from 'angular-resizable-element'
import { MatIconModule } from '@angular/material/icon';
import { BingMapModule } from '../bing-map/bing-map.module';
import { AngularUpgradeHelper } from '../helpers/AngularUpgradeHelper';

@NgModule({
    imports: [ResizableModule, MatIconModule, BingMapModule],
    declarations: [ResizableMapComponent],
    exports: [ResizableMapComponent]
})
export class ResizableMapModule {
    private commonModuleName = 'app.areas.commonModule';

    constructor() {
        AngularUpgradeHelper.downgradeComponents(this.commonModuleName, [
            ResizableMapComponent
        ]);
    }
}